// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"8bcafafa","205":"37154704","268":"ad13ae78","345":"509b7468","572":"150bea55","647":"730e9660","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};